"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var handleAxiosResponseSuccess_1 = __importDefault(require("./utils/handleAxiosResponseSuccess"));
var handleAxiosResponseError_1 = __importDefault(require("./utils/handleAxiosResponseError"));
var Http = axios_1.default.create();
var Service = /** @class */ (function () {
    function Service() {
    }
    Service.setBaseUrl = function (baseUrl) {
        Http.defaults.baseURL = baseUrl;
    };
    Service.getBaseUrl = function () {
        return Http.defaults.baseURL;
    };
    Service.setRequestInterceptors = function (onFulfilled, onRejected) {
        Http.interceptors.request.use(onFulfilled, onRejected);
    };
    Service.setResponseInterceptors = function (onFulfilled, onRejected) {
        Http.interceptors.response.use(onFulfilled, onRejected);
    };
    Service.Http = Http;
    Service.getData = getData;
    return Service;
}());
function getData(response) {
    return response.data;
}
Http.interceptors.response.use(handleAxiosResponseSuccess_1.default, handleAxiosResponseError_1.default);
exports.default = Service;
